import React, { Component } from "react"
import { Modal, Select, Row, Col } from "antd"
import { error_manager } from "helper/error_manager"
import cookie from "react-cookies"
import {isSuperuser} from "../../../utils/utils";

class ConfirmGroupChange extends Component {
    constructor(props) {
        super(props)

        this.state = {
            group: this.props.selectedGroup,
        }

        this.is_superuser = isSuperuser()
    }

    organisation = Number.parseInt(cookie.load("organisation_id") || 0)

    disabled = () => !(this.state.group)

    changeGroup = () => {
        if (this.disabled()) {
            error_manager("Invalid Group, or Action")
            return 
        }

        this.props.setGroupUsers({
            group: this.state.group,
            action: this.props.action,
            usernames: this.props.usernames
        })
        this.props.closeModal()
    }

    renderUsernames = () => (
        <ul>
            {this.props.usernames.map(e => <li>{e}</li>)}
        </ul>
    )

    render() {
        const validOptions = this.is_superuser ? this.props.allGroups : this.props.allGroups?.filter(({ organisation }) => organisation === this.organisation)
        return (
            <Modal
                title={"Change User Groups"}
                visible={this.props.showModal}
                onOk={() => this.changeGroup()}
                onCancel={this.props.closeModal}>
                <React.Fragment>
                    <Row>
                        {'Selected Users'}
                        {this.renderUsernames()}
                    </Row>
                    <Row>
                        <div>{`Please select/verify group to ${this.props.action}`}</div>
                    </Row>
                    <Row className="add-case-row-popup">
                        <Col span={5} className="add-case-row-header">
                            <b>Group</b>
                        </Col>
                        <Col span={8}>
                            <Select
                                showSearch
                                className="input-field-add-case"
                                value={this.state.group}
                                onChange={(group) => this.setState({ group })}
                                disabled={!!this.props.selectedGroup}
                            >
                                {validOptions?.map(({ name }) =>
                                        <Select.Option value={name}>{name}</Select.Option>)}
                            </Select>
                        </Col>
                    </Row>
                </React.Fragment>
            </Modal>
        )
    }
}

export default ConfirmGroupChange